import * as React from "react";
import {
  Box,
  Grid,
  Typography,
  Tab,
  Tabs,
  Switch,
  Button,
} from "@mui/material";
import GlobalPopUp from "../../Components/global/globalPopUp/GLobalPopUp";
import TableComponent from "../../Components/tableComponent/tableComponent";
import agent from "../../API/apiCalls";
import {
  GetThreePsRespModel,
  UpdateThreePSPayloadModel,
} from "../../Models/tableDetailsModel";
import { UserContext, UserPayload } from "../../Context/userContext";
import HistoryIcon from '@mui/icons-material/History';
import { threePsStyles } from "./threePsStyles";
import TabPanel from "../../Components/tabPanel/tabPanel";
import { a11yProps } from "../../utils/a11yProps";

export default function ThreePS() {

  const { classes } = threePsStyles();

  const {
    SaveChangesButtonStyle,
    threePsCard
  } = classes;
  
  const { setShowLoader } = React.useContext(UserContext) as UserPayload;
  const [threePsSwitch, setThreePsSwitch] = React.useState<
    GetThreePsRespModel[] | null
  >(null);
  const [threepsHistoryData, setThreepsHistoryData] = React.useState<
    GetThreePsRespModel[] | null
  >(null);
  const [value, setValue] = React.useState(0);
  const [changedSwitches, setChangedSwitches] = React.useState<
    { threePsApiTaxoId: number }[]
  >([] as { threePsApiTaxoId: number }[]);
  const [flagConfirmation, setFlagConfirmation] = React.useState(false);
  const handleSwitchChange = (threePsApiTaxoId: number, checked: boolean) => {
    if (checked !== getDefaultSwitchValue(threePsApiTaxoId)) {
      // Switch value has changed, add to the array
      setChangedSwitches((prevSwitches: { threePsApiTaxoId: number }[]) => {
        if (
          !prevSwitches.some(
            (switchObj) => switchObj.threePsApiTaxoId === threePsApiTaxoId
          )
        ) {
          return [...prevSwitches, { threePsApiTaxoId }];
        }
        return prevSwitches;
      });
    } else {
      // Switch value returned to default, remove from the array
      setChangedSwitches((prevSwitches) =>
        prevSwitches.filter(
          (switchObj) => switchObj.threePsApiTaxoId !== threePsApiTaxoId
        )
      );
    }
  };

  const getDefaultSwitchValue = (threePsApiTaxoId: number) => {
    const switchObj =
      threePsSwitch !== null &&
      threePsSwitch.find((item) => item.threePsApiTaxoId === threePsApiTaxoId);
    return switchObj ? switchObj.currentStatus : false;
  };
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeToggle = (event: string) => {
    // setSubType(event)
    setShowConfirmation(true);
  };
  const updateThreePsStatus = async () => {
    const response = await agent.UpdateLNIDStatus.put();
    if (response.flagStatus) {
    }
  };

  const getThreePsList = async (threePsApiTaxoId: number) => {
    setChangedSwitches([])
    setShowLoader(true);
    const response = await agent.GetThreePsHistoryData.get(threePsApiTaxoId);
    setThreepsHistoryData(
      response.value.sort(
        (a: any, b: any) =>
          new Date(b.updatedOn).valueOf() - new Date(a.updatedOn).valueOf()
      )
    );
    setShowLoader(false);
  };

  const handleConfirmation = () => {
    UpdateThreePsApi(changedSwitches);
    // updateLNIDStatus();
  };
  // React.useEffect(()=>{
  //   console.log("lnid list")
  // },[lnidList])

  // React.useEffect(()=>{
  //   getLNIDList()
  // },[toggleState])

  const getThreePsSwitch = async () => {
    setChangedSwitches([]);
    setShowLoader(true);
    const response = await agent.GetThreePsSwitch.get();
    setThreePsSwitch(response.value);
    setShowLoader(false);
  };
  React.useEffect(() => {
    getThreePsSwitch();
  }, []);

  const UpdateThreePsApi = async (payload: UpdateThreePSPayloadModel[]) => {
    const response: any = await agent.UpdateThreePs.post(payload);
    if (response.flagStatus) {
      setFlagConfirmation(false);
      getThreePsSwitch();
    }
  };
  return (
    <>
      <>
        <GlobalPopUp
          HandleLnidThreePsChange={handleConfirmation}
          heading="Three PS Confirmation"
          message={`Are you sure you want these changes?`}
          flagPopUp={flagConfirmation}
          setflagPopUp={setFlagConfirmation}
          section="changeLNID"
        />
        <Grid container>
          <Grid item sx={{ width: "100%", marginTop: "15px", height: "100%" }}>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab sx={{textTransform:"unset",fontWeight:"600",fontSize:"15px"}} label="3PS Config" {...a11yProps(0)} />

                  {threePsSwitch !== null &&
                    threePsSwitch.map(
                      (threePsSwitch: GetThreePsRespModel, index) => (
                        <Tab
                        sx={{textTransform:"unset",fontWeight:"600",color:"#7A7A7A",fontSize:"15px" }}
                          label={`${threePsSwitch.threePsApiTaxoName} History`}
                          {...a11yProps(index + 1)}
                          onClick={() => {
                            getThreePsList(
                              threePsSwitch.threePsApiTaxoId !== null
                                ? threePsSwitch.threePsApiTaxoId
                                : -1
                            );
                          }}
                        />
                      )
                    )}
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <Grid container direction={"column"} justifyContent={"start"}>
                  <Grid item sx={{display:'flex'}}>
                  {threePsSwitch !== null &&
                    threePsSwitch.map(
                      (threePsSwitchObj: GetThreePsRespModel,index) => (
                        <>
                        <Grid container direction="column" className={threePsCard}>
                          <Grid item>
                            <Grid container justifyContent={"space-between"}>
                              <Grid item sx={{fontSize:"15px",fontWeight:"600"}}>{threePsSwitchObj.threePsApiTaxoName}</Grid>
                              <Grid item><HistoryIcon sx={{cursor:"pointer"}} onClick={()=>{setValue(index+1);getThreePsList(
                              threePsSwitchObj.threePsApiTaxoId !== null
                                ? threePsSwitchObj.threePsApiTaxoId
                                : -1
                            ) }}/></Grid>
                            </Grid>
                          </Grid>
                          <Grid item>
                              <Switch
                              defaultChecked={ threePsSwitchObj.currentStatus == null? false :threePsSwitchObj.currentStatus}
                                value={threePsSwitchObj.threePsApiTaxoName}
                                // onChange={(e)=>{console.log(e.target.checked)}}
                                onChange={(e) =>
                                  handleSwitchChange(
                                    threePsSwitchObj.threePsApiTaxoId == null
                                      ? -1
                                      : threePsSwitchObj.threePsApiTaxoId,
                                    e.target.checked
                                  )
                                }
                              />
                          </Grid>
                        </Grid>
                         
                        </>
                      )
                    )}
                    </Grid>
                     <Grid item>
                        <Button
                        sx={{textTransform:"unset",marginTop:"30px", opacity:changedSwitches.length>0? "1" : "0.5"}}
                        className={SaveChangesButtonStyle}
                          onClick={() => {
                            setFlagConfirmation(true);
                          }}
                          disabled={changedSwitches.length>0? false : true}
                        >
                          Save Changes
                        </Button>
                      </Grid>
                </Grid>
              </TabPanel>
              {threePsSwitch !== null &&
                threePsSwitch.map(
                  (threePsSwitch: GetThreePsRespModel, index) => (
                    <TabPanel value={value} index={index + 1}>
                      <TableComponent rows={threepsHistoryData?.slice(0, 10)} />
                    </TabPanel>
                  )
                )}
            </Box>
            {/* table */}
          </Grid>
         
          </Grid>
      </>
    </>
  );
}
